import { EDIT_AGENT, EDIT_AGENT_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const editAgentRoute = createGlobalRoute({
  exact: true,
  name: EDIT_AGENT_PAGE,
  path: EDIT_AGENT,
  layout: 'home',
  nav4Layout: 'expanded',
  query: [
    'rovoChat!=false',
    'rovoChat.agentId!=false',
    'rovoChat.cloudId!=false',
    'rovoChat.conversationId!=false',
    'rovoChat.pathway!=false',
    'rovoChat.prompt!=false',
    'rovoChat!=false',
    'rovoChatAgentId!=false',
    'rovoChatCloudId!=false',
    'rovoChatConversationId!=false',
    'rovoChatPathway!=false',
    'rovoChatPrompt!=false',
    'rovoChatTriggerOpen!=false',
  ],
});
